module.exports = require("./es-GQ.d.ts");